import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Item } from '../../model/item';
import { AnswerControlService } from '../answer/answerControl.service';
import { State } from "../../model/state";
import { CONFIG } from '../../constants/constants';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { ItemControlService } from "../../services/item/item-control.service";
import { RevisionRespuestas } from '../../model/RevisionRespuestas';
import { TokenControlService } from '../state/tokenControl.service';
import { TYPE_ROLES } from '../../constants/typeRoles';
import { AnswerService } from '../answer/answer.service';
import { WelcomeService } from '../welcome/welcome.service';

/*Servicio principal para Items*/
@Injectable({
  providedIn: 'root'
})
export class ItemService {

  //objeto para acceder a la base de datzos IndexedDB
  private dataBase: any = null;
  public progressBar: Item;
  public items: Item[];
  public revisionRespuestas: RevisionRespuestas[]
  public revisionRespuestaActual: RevisionRespuestas
  public activarReviewRole: boolean = false

  //constructor de la clase
  constructor(private http: HttpClient,
    private _answerController: AnswerControlService,
    private _welcomeDataService: WelcomeService,
    private _configurationControlService: ConfigurationControlService,
    private _tokenController: TokenControlService,
    private _itemControlService: ItemControlService) {
  }

  public actualizarAllRevisionRespuestas(activar: boolean = false) {
    if (this._tokenController.token.userType != TYPE_ROLES.REVIEW)
      return

    this.activarReviewRole = activar

    if (this.revisionRespuestas == null) {
      this.getRemotoRevisionRespuestas(
        this._tokenController.token.tokenId,
        this._tokenController.token.token,
        this._tokenController.token.credentialId
      ).then(respuestas => {
        this.revisionRespuestas = respuestas
      });
    }
  }

  public actualizarRevisionRespuesta(itemId: number): RevisionRespuestas {
    if (this._tokenController.token.userType != TYPE_ROLES.REVIEW)
      return new RevisionRespuestas()

    if (this.revisionRespuestas == null) {
      this.getRemotoRevisionRespuestas(
        this._tokenController.token.tokenId,
        this._tokenController.token.token,
        this._tokenController.token.credentialId
      ).then(respuestas => {
        this.revisionRespuestas = respuestas
        this.revisionRespuestaActual = this.revisionRespuestas.find((revision) => {
          return revision.idItem == itemId
        })
      });
    }


    if (this.revisionRespuestas) {
      this.revisionRespuestaActual = this.revisionRespuestas.find((revision) => {
        return revision.idItem == itemId
      })
    }

    return this.revisionRespuestaActual
  }

  public getRevisionRespuestaAcutal(): RevisionRespuestas {
    if (this._tokenController.token.userType != TYPE_ROLES.REVIEW)
      return new RevisionRespuestas()

    if (this.revisionRespuestaActual)
      return this.revisionRespuestaActual

    return new RevisionRespuestas()
  }

  public getRespuestaCorrecta(): String {
    if (this._tokenController.token.userType != TYPE_ROLES.REVIEW)
      return ""

    return this.getRevisionRespuestaAcutal().answerCorrecta
  }

  public getRespuestaMarcadaExaminado(): String {
    if (this._tokenController.token.userType != TYPE_ROLES.REVIEW)
      return ""
    const answerUser = this.getRevisionRespuestaAcutal().answerUser

    if (answerUser == null || answerUser == "") {
      return "-"
    }
    return answerUser
  }

  //Se encarga de inicializar la base de datos IndexedDB
  public initDb() {
    let self = this;
    return new Promise<void>(resolve => {
      console.log(CONFIG.DB_NAME);

      self.dataBase = indexedDB.open(CONFIG.DB_NAME);
      self.dataBase.onupgradeneeded = function (event) {
        let conection = self.dataBase.result;
        let itemsStore = conection.createObjectStore(
          CONFIG.ITEMS_STORE,
          { keyPath: 'itemId', autoIncrement: false }
        );
        itemsStore.createIndex('by_order',
          ['order',
            'sesion'],
          { unique: true });
        let answerStore =
          conection.createObjectStore(
            CONFIG.ANSWER_STORE,
            { keyPath: 'respuestaId', autoIncrement: true });
        answerStore.createIndex(
          'by_synchronized',
          CONFIG.SYNC_ANSWER_INDEX,
          { unique: false });
        answerStore.createIndex(
          'by_answerId',
          'itemId',
          { unique: false });
        answerStore.createIndex(
          'by_max_date',
          ['fechaRespuesta',
            'itemId'],
          { unique: false });
        let tokenStore =
          conection.createObjectStore(
            CONFIG.TOKEN_STORE,
            { keyPath: 'tokenId', autoIncrement: false });
        tokenStore.createIndex(
          'by_tokenId',
          'tokenId',
          { unique: true });
        let stateStore =
          conection.createObjectStore(
            CONFIG.STATE_STORE,
            { keyPath: 'consecutive', autoIncrement: false });
        stateStore.createIndex(
          'by_consecutive',
          'consecutive',
          { unique: true });
      }
      self.dataBase.onsuccess = function (event) {
        resolve();
      }
      self.dataBase.onerror = function (event) {
        console.log('...error opening dataBase...');
        resolve();
      }
    });
  }

  /*Se encarga de consultar las respuestas finales de un usuario CSJ
  que se encuentran en base de datos, invoca un servicio de plexi-rest que se encarga de consultar
  el listado de respuestas marcadas y respuestas correctas del usuario*/
  public getRemotoRevisionRespuestas(user: string, token: string, credencialId: number): Promise<Array<RevisionRespuestas>> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'user': user,
      'user_id': credencialId.toString(),
    });

    return this.http.get<Array<RevisionRespuestas>>(CONFIG.REST_END_POINT + 'revisionRespuestas/', { headers: _headers }).toPromise();

  }

  /*Se encarga de consumir el servicio de plexi-rest
    que consulta los items basado en el nombre de usuario*/
  public resolveItems(user: string, token: string): Promise<Item[]> {
    let self = this;
    return new Promise(
      resolve => {
        this.items = [];
        if (token) {
          let _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'token': token,
            'user': user
          });
          this.http.get(
            CONFIG.REST_END_POINT + 'resolveItems/',
            { headers: _headers })
            .subscribe(
              (data: any) => {
                self._itemControlService.totalItems = data;
                self._answerController.totalItems = data.length;
                for (let item of data) {
                  const itemObtenido = new Item(item['itemId'],
                    item['content'],
                    item['orderVisual'],
                    item['sesion'],
                    item['sesions'],
                    item['total'],
                    item['testName'],
                    item['type'],
                    item['itemChild'],
                    item['order'],
                    item['totalVisual'],
                    item['recursosItem'],
                    item['itemNumero'],
                    null,
                    0,
                    null
                  );
                  self.items.push(itemObtenido);
                }

                resolve(this.items);
              },
              err => {
                resolve(null);
              }
            );
        } else {
          resolve(null);
        }
      }
    );
  }
  // public resolveItems(user: string, token: string): Observable<Item[]> {
  //   let self = this;
  //   this.items = [];

  //   let _headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'token': token,
  //     'user': user
  //   });
  //   return this.http.get<Item[]>(CONFIG.REST_END_POINT + 'resolveItems/', { headers: _headers });


  // }


  /*Se encarga de obtener un item del store en indexedDB basado en el id*/
  public getItem(itemId: number): Promise<Item> {
    return new Promise(resolve => {
      let connection = this.dataBase.result;
      let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readonly');
      let objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
      let request = objStore.get(itemId);
      request.onsuccess = function (event: any) {
        resolve(request.result);
      }
      request.onerror = function (event: any) {
        console.log('...Error obteniendo item ' + itemId + '...');
      }
    });
  }


  /*Se encarga de actualizar un item en el store en indexedDB*/
  public updateItem(item: Item): Promise<string> {
    let self = this;
    return new Promise(resolve => {
      self.addItem(item);
    });
  }


  /*Se encarga de obtener un item desde indexedDB dado su id*/
  public getItemById(itemId: number): Promise<Item> {
    return new Promise(resolve => {
      let self = this;
      let result: Item;
      self.dataBase = indexedDB.open(CONFIG.DB_NAME);
      self.dataBase.onsuccess = function (event: any) {
        resolve(self.getItem(itemId));
      }
      self.dataBase.onerror = function (event: any) {
        console.log('...error opening dataBase...');
      }

    });
  }


  /*Se encarga de obtener un item desde indexedDB dado su
    orden y su sesion*/
  public getItemByOrder(order: number, sesion: number): Promise<Item> {
    let self = this;
    return new Promise(resolve => {
      self.initDb().then(res => {
        let connection = self.dataBase.result;
        let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readonly');
        let objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
        let index = objStore.index('by_order');
        let request = index.openCursor(IDBKeyRange.only([order, sesion]));
        request.onsuccess = function (event: any) {
          console.log('cursor found');
          let cursor = request.result;
          console.log(cursor);
          if (cursor) {
            resolve(cursor.value as Item);
          } else {
            resolve(null);
          }
        }
        request.onerror = function (event: any) {
          console.log('...Error obteniendo item ' + order + '...');
        }
      });
    });
  }

  /*Se encarg de traer un Item segun su codigo*/
  public resolveItemByCode(code: string, token: string, userName: string, sesion: string): Promise<Item> {
    if (token) {
      let _headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'token': token,
        'itemCode': code,
        'sesion': sesion,
        'user': userName
      });
      return this.http.get<Item>(CONFIG.REST_END_POINT + 'getItem/', { headers: _headers })
        .toPromise();
    } else {
      return null;
    }
  }


  public addItemsAll(items: Item[]) {
    return new Promise<void>(async (resolve, reject) => {
      if (this.dataBase == null) {
        await this.initDb();
      }
      const connection = this.dataBase.result;
      const transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readwrite');
      const objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
      items.forEach((item: Item) => {
        const dbReqeust = objStore.put(item);
        dbReqeust.onerror = function (event: any) {
          console.log('...Error insertando item ' + item.itemId + '...');
        }
      })
      transaction.oncomplete = function (event: any) {
        console.log('...TRANSACCION EXITOSA ...');
        resolve();
      }
    });
  }

  /*Se encarga de agregar un item al store en indexedDB*/
  public addItem(item: Item) {
    if (this._configurationControlService.examConfiguration.typeTest == '1') {
      let connection = this.dataBase.result;
      let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readwrite');
      let objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
      let request = objStore.put(item);
      console.log("request", request)
      request.onerror = function (event: any) {
        console.log('...Error insertando item ' + item.itemId + '...');
      }
      transaction.oncomplete = function (event: any) {
        console.log('...Transaccion Exitosa...');
      }
    }
  }


  /*Se encarga de almacenar el estado en el store en indexedDB*/
  public saveState(state: State): Promise<String> {
    let self = this;
    return new Promise(
      resolve => {
        let connection = self.dataBase.result;
        let transaction = connection.transaction([CONFIG.STATE_STORE], 'readwrite');
        let objStore = transaction.objectStore(CONFIG.STATE_STORE);
        let objectStoreRequest = objStore.clear();
        objectStoreRequest.onsuccess = function (event: any) {
          let transactionAns =
            connection.transaction([CONFIG.STATE_STORE], 'readwrite');
          let objStoreAns = transactionAns.objectStore(CONFIG.STATE_STORE);
          let request = objStore.put(state);
          request.onerror = function (event: any) {
            console.log('...Error guardando estado ');
            resolve('ERROR');
          }
          transaction.oncomplete = function (event: any) {
            resolve('OK');
          }
        }
      }
    );
  }


  /*Se encarga de consultar el estado del store en indexedDB*/
  public getState(): Promise<State> {
    let self = this;
    return new Promise(
      resolve => {
        self.initDb().then(result => {
          let connection = self.dataBase.result;
          let transaction = connection.transaction([CONFIG.STATE_STORE], 'readonly');
          let objStore = transaction.objectStore(CONFIG.STATE_STORE);
          let index = objStore.index('by_consecutive');
          let request = index.openCursor(IDBKeyRange.only(1));
          request.onsuccess = function (event: any) {
            let cursor = request.result;
            if (cursor) {
              resolve(cursor.value as State);
            } else {
              resolve(null);
            }
          }
          request.onerror = function (event: any) {
            console.log('...Error obteniendo estado ');
            resolve(null);
          }
        });
      }
    );
  }


  /*Se encarga de consultar los items ordenados, por sesión*/
  public getItemsBySesion(totalItems: number, sesionActual: number): Promise<Item[]> {
    let self = this;
    let items: Item[] = [];
    return new Promise(resolve => {
      let connection = this.dataBase.result;
      let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readonly');
      let store = transaction.objectStore(CONFIG.ITEMS_STORE);
      let index = store.index('by_order');

      for (var indice = 1; indice <= totalItems; indice++) {
        let request = index.openCursor(IDBKeyRange.only([indice, sesionActual]));
        request.onsuccess = function (event: any) {
          let cursor = request.result;
          if (cursor) {
            let itemSearch: Item = new Item(cursor.value.itemId,
              cursor.value.content,
              cursor.value.orderVisual,
              cursor.value.sesion,
              cursor.value.sesions,
              cursor.value.total,
              cursor.value.testName,
              cursor.value.type,
              cursor.value.itemChild,
              cursor.value.order,
              cursor.value.totalVisual,
              cursor.value.recursosItem,
              cursor.value.itemNumero,
              null,
              0,
              null
            );
            items.push(itemSearch);
            cursor.continue();
          } else {
            resolve(items);
          }
        }
      }
    });
  }


}

